export const powerCube = `<img src="/img/pay/power-cube.webp" alt="能量块" style="width: 1em; height: 1em; vertical-align: -0.15em; display:inline-block; margin:0;" />`;

export const goldTicketRules = `
<li>
  金票可以投给角色/故事/视觉小说/合集任意品类（不可以投给自己的作品），必须实名投票，必须写出200字以上推荐理由，才可以投票
</li>
<li>成功投出当期金票，委员会成员将获得 ${powerCube} 800 奖励</li>
<li>
  获得金票的角色/故事/视觉小说/合集，每张金票将按比例折算为普票，参加当期排名
</li>
<li>
  折算比例：1金票 = 上期排行榜总票数的3% , （第一、二期时，暂定1金票=100普票）
</li>
`;

export const seniorReaderRules = `
<h3>为何要成为资深读者？</h3>
<ol>
  <li>成为资深读者后，在每个评奖周期，都拥有1票“金票”</li>
  ${goldTicketRules}
</ol>
`;

export const rankRules = `
<h2>一、评奖机制</h2>
<ol>
  <li>每月评定一次，1日开始评定周期，当月最后一天结束</li>
  <li>创作没有任何题材/风格的限制，但不能涩涩，不能违法</li>
  <li>
    在该评奖周期内，更新量达到基本要求的角色、故事、视觉小说、合集，将自动获得评奖资格
  </li>
  <li>
    读者的推荐票是决定评奖结果的唯一依据，具体以Anymate平台的"排行"板块为主
  </li>
  <li>推荐票每期结束后都会清零，下一期从新开始计算</li>
  <li>活跃的读者才能拥有更多的推荐票</li>
  <li>所有投票底稿都是公开透明的，可以随时查看</li>
  <li>所有内容，须在本期内有相应更新才有资格获取奖金，具体规则如下：
      <ul>
        <li>视觉小说：本期内视觉小说更新字数超过3000字</li>
        <li>故事：本期内更新字数超过1500字</li>
        <li>角色：本期内饼友圈更新数大于5</li>
        <li>合集：合集的共建人数大于2人, 本期新增内容大于10</li>
      </ul>
  </li>
</ol>
<h2>二、奖金</h2>
<ol>
  <li>奖金每月评奖，总榜前60名均可获奖（但最少要获得10票才具备领奖资格）具体为：</li>
</ol>
<blockquote>
  <div>第1名：${powerCube} 10000</div>
  <div>第2名：${powerCube} 8000</div>
  <div>第3名：${powerCube} 6000</div>
  <div>第4名：${powerCube} 5000</div>
  <div>第5名：${powerCube} 4400</div>
  <div>第6名：${powerCube} 4000</div>
  <div>第7名：${powerCube} 3600</div>
  <div>第8名：${powerCube} 3000</div>
  <div>第9名：${powerCube} 2400</div>
  <div>第10名：${powerCube} 2000</div>
  <div>第11~60名：平均瓜分 ${powerCube} 63500</div>
</blockquote>
<ol start="2">
  <li>
    奖金发放时间：当期评奖结束后3个工作日（期间会进行核票、刷票检查、举报核查等工作）
  </li>
  <li>
    如在核票过程中发现问题，将剔除问题作品，排名在其后的作品进行递补
  </li>
  <li>如有并列，并列者平分该档奖金</li>
</ol>
<h2>三、防刷票</h2>
<ol>
  <li>每用户每天投票上限为 10 票</li>
  <li>匿名投票必须写 10 字以上的评论</li>
  <li>系统判定为“疑似刷票用户”将限制投票行为</li>
</ol>
<h2>四、金票</h2>
<p>我们通过"金票"机制来保护优秀创作者：</p>
<ol>
  <li>
    由“资深读者&amp;平台编辑部”组成的10人委员会，成员定期更新，确保不会僵化。如发现水票或舞弊或不作为等行为，则随时更换成员
  </li>
  <li>
    每位委员会成员，在每个评奖周期，都拥有1票“金票”，金票当期如果不用，下期清零
  </li>
  ${goldTicketRules}
</ol>
`;
